/** Return a Teams model that has even teams (doesnt care about wantsToJoinTeam property) */
export function buildTeamsEvenly(combatants={}) {
  let result = {
    "one": {
      combatantIds: [],

    },
    "two": {
      combatantIds: [],

    }
  };

  Object.keys(combatants).forEach((combId, i) => {
    const teamId = (i % 2 === 0) ? "one" : "two";
    result[teamId].combatantIds.push(combId);
  });



  return {...result};

}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/build-teams-evenly.js